"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AppcuesThemeProvider = _interopRequireDefault(require("./AppcuesThemeProvider.js"));

var _chunk5ef88ed = require("./chunk-5ef88ed1.js");

var _Toast = _interopRequireDefault(require("./Toast.js"));

var _Portal = _interopRequireDefault(require("./Portal.js"));

require("prop-types");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

require("./chunk-76875e58.js");

require("./chunk-eb19ede6.js");

require("./chunk-8219403d.js");

require("classnames");

require("./CFontIcon.js");

require("./layout.js");

require("./chunk-b15f6972.js");

require("./chunk-6104512b.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./CButton.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  pointer-events: none;\n\n  position: fixed;\n  bottom: 0;\n  left: 0;\n\n  z-index: 10000;\n\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CToaster = function (_PureComponent) {
  (0, _chunkB2edacfb.f)(CToaster, _PureComponent);

  function CToaster() {
    var _getPrototypeOf2;

    var _this;

    (0, _chunkB2edacfb.b)(this, CToaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _chunkB2edacfb.d)(this, (_getPrototypeOf2 = (0, _chunkB2edacfb.e)(CToaster)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "toastId", 0);
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "state", {
      toasts: []
    });
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "dismiss", function (key, timeoutExpired) {
      _this.setState(function (_ref) {
        var toasts = _ref.toasts;
        return {
          toasts: toasts.filter(function (toast) {
            var matchesKey = toast.key === key;

            if (matchesKey && toast.onDismiss) {
              toast.onDismiss(timeoutExpired);
            }

            return !matchesKey;
          })
        };
      });
    });
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "clear", function () {
      var toasts = _this.state.toasts;
      toasts.forEach(function (toast) {
        return toast.onDismiss && toast.onDismiss(false);
      });

      _this.setState({
        toasts: []
      });
    });
    (0, _chunkB2edacfb.h)((0, _chunkB2edacfb.m)(_this), "getToasts", function () {
      return _this.state.toasts;
    });

    _isNewToastKey.set((0, _chunkB2edacfb.m)(_this), {
      writable: true,
      value: function value(key) {
        return _this.state.toasts.every(function (toast) {
          return toast.key !== key;
        });
      }
    });

    _createToastOptions.set((0, _chunkB2edacfb.m)(_this), {
      writable: true,
      value: function value(props) {
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "toast-".concat(_this.toastId++);
        return (0, _chunkB2edacfb.i)({}, props, {
          key: key
        });
      }
    });

    _getDismissHandler.set((0, _chunkB2edacfb.m)(_this), {
      writable: true,
      value: function value(toast) {
        return function (timeoutExpired) {
          _this.dismiss(toast.key, timeoutExpired);
        };
      }
    });

    return _this;
  }

  (0, _chunkB2edacfb.c)(CToaster, [{
    key: "show",
    value: function show(props, key) {
      var options = (0, _chunkB2edacfb.n)(this, _createToastOptions).call(this, props, key);

      if (key === undefined || (0, _chunkB2edacfb.n)(this, _isNewToastKey).call(this, key)) {
        this.setState(function (prevState) {
          return {
            toasts: [].concat((0, _chunkB2edacfb.k)(prevState.toasts), [options])
          };
        });
      } else {
        this.setState(function (prevState) {
          return {
            toasts: prevState.toasts.map(function (toast) {
              return toast.key === key ? options : toast;
            })
          };
        });
      }

      return options.key;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var toasts = this.state.toasts;
      return _react.default.createElement(_Portal.default, null, _react.default.createElement(_AppcuesThemeProvider.default, null, _react.default.createElement(_chunk5ef88ed.b, {
        appear: true,
        enter: true,
        exit: true,
        mountOnEnter: true,
        unmountOnExit: true,
        component: Container
      }, toasts.map(function (toast, i) {
        return _react.default.createElement(_chunk5ef88ed.a, {
          key: toast.key,
          classNames: "toast",
          timeout: {
            enter: 10,
            exit: 210
          }
        }, _react.default.createElement(_Toast.default, (0, _chunkB2edacfb.g)({}, toast, {
          onDismiss: (0, _chunkB2edacfb.n)(_this2, _getDismissHandler).call(_this2, toast)
        })));
      }))));
    }
  }], [{
    key: "create",
    value: function create() {
      var _ref2;

      var containerElement = document.createElement("div");

      _reactDom.default.render(_react.default.createElement(CToaster, {
        ref: function ref(componentRef) {
          _ref2 = componentRef;
        }
      }), containerElement);

      return _ref2;
    }
  }]);
  return CToaster;
}(_react.PureComponent);

var _isNewToastKey = new WeakMap();

var _createToastOptions = new WeakMap();

var _getDismissHandler = new WeakMap();

var Container = _styledComponents.default.div.withConfig({
  displayName: "CToaster__Container",
  componentId: "sc-1q8nsq4-0"
})(_templateObject());

var _default = CToaster;
exports.default = _default;